import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { API, errText } from "@/site/common";
import { hasToken, memberApi, useMember } from "@/site/member";
import { AuthShell } from "@/site/auth/AuthShell";

const link = "mt-4 inline-flex rounded-xl bg-orange-500 hover:bg-orange-600 text-white font-bold px-5 py-3 transition-colors";

export default function VerifyEmail() {
  const [q] = useSearchParams(), token = q.get("token") || "", { setMember } = useMember();
  const [state, setState] = useState(token ? "busy" : "err"), [msg, setMsg] = useState(token ? "" : "Bağlantı eksik. E-postadaki bağlantıya tekrar tıklayın.");
  const ran = useRef(false);
  useEffect(() => {
    document.title = "E-posta doğrulama · Emlak Sepeti";
    if (!token || ran.current) return;
    ran.current = true;
    memberApi.post(`${API}/member/verify-email`, { token }).then(() => {
      setState("ok");
      if (hasToken()) memberApi.get(`${API}/member/me`).then((r) => setMember?.(r.data)).catch(() => {});
    }).catch((e) => { setState("err"); setMsg(errText(e)); });
  }, [token, setMember]);
  return (
    <AuthShell title="E-posta doğrulama" sub="Hesabınızın e-posta adresini doğruluyoruz." testid="site-verify-email-page">
      {state === "busy" && <p className="flex items-center gap-3 text-slate-600" data-testid="verify-email-busy"><Loader2 className="animate-spin text-orange-500" />Doğrulanıyor…</p>}
      {state === "ok" && <div className="rounded-2xl bg-emerald-50 border border-emerald-200 p-5 text-emerald-800" data-testid="verify-email-ok"><CheckCircle2 className="mb-3" /><b className="block">E-posta adresiniz doğrulandı</b><p className="mt-1.5 text-sm">Profilinizde ve ilanlarınızda artık "E-posta doğrulandı" rozeti görünür.</p><Link to="/hesabim/profil" className={link} data-testid="verify-email-go-profile">Profilime git</Link></div>}
      {state === "err" && <div className="rounded-2xl bg-red-50 border border-red-200 p-5 text-red-700" data-testid="verify-email-error"><XCircle className="mb-3" /><b className="block">Doğrulama yapılamadı</b><p className="mt-1.5 text-sm">{msg}</p><Link to="/hesabim/profil" className={link}>Hesabım → Profilim</Link></div>}
    </AuthShell>
  );
}
